import { useTranslation } from 'react-i18next';

import { Description, TextWrapper, Text, Wrapper } from './EmptyLiveRecords.styles';

const ICON_SIZE = 30;

export const EmptyLiveRecords: React.FC = () => {
  const { t } = useTranslation('StudentCourseSummaryTranslations');

  return (
    <Wrapper>
      <span role="img" aria-label="Empty live records" style={{ fontSize: ICON_SIZE }}>
        🧑‍💻
      </span>
      <TextWrapper>
        <Text>{t('EMPTY_LIVE_RECORDS_TITLE')}</Text>
        <Description>{t('EMPTY_LIVE_RECORDS_CONTENT')}</Description>
      </TextWrapper>
    </Wrapper>
  );
};
